var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorageWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 25H32.5V27.5H35V35H5V27.5H7.5V25H5C4.33716 25.0007 3.70166 25.2643 3.23296 25.733C2.76427 26.2017 2.50066 26.8372 2.5 27.5V35C2.50066 35.6628 2.76427 36.2983 3.23296 36.767C3.70166 37.2357 4.33716 37.4993 5 37.5H35C35.6628 37.4993 36.2983 37.2357 36.767 36.767C37.2357 36.2983 37.4993 35.6628 37.5 35V27.5C37.4993 26.8372 37.2357 26.2017 36.767 25.733C36.2983 25.2643 35.6628 25.0007 35 25V25Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 32.5C9.44036 32.5 10 31.9404 10 31.25C10 30.5596 9.44036 30 8.75 30C8.05964 30 7.5 30.5596 7.5 31.25C7.5 31.9404 8.05964 32.5 8.75 32.5Z",
    fill: "#FCFCFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 25H10V16.25H18.75V25ZM12.5 22.5H16.25V18.75H12.5V22.5ZM30 25H21.25V16.25H30V25ZM23.75 22.5H27.5V18.75H23.75V22.5ZM18.75 13.75H10V5H18.75V13.75ZM12.5 11.25H16.25V7.5H12.5V11.25ZM30 13.75H21.25V5H30V13.75ZM23.75 11.25H27.5V7.5H23.75V11.25Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageWhite);
export default __webpack_public_path__ + "static/media/storage-white.a1c1a204896b47311145374955c28d25.svg";
export { ForwardRef as ReactComponent };